
import { Module } from 'vuex'

const user: Module<any, unknown> = {
  namespaced: true,
  state: {},
  mutations: {
    setUser (state: any, user: any) {
      state.user = user
    },
    setCompany (state: any, company: any) {
      state.company = company
    }
  },
  getters: {},
  actions: {}
}

export default user
